export default __webpack_public_path__ + "static/media/pricemodel.0ff63c4d.xlsx";